import React from 'react';
import HitModal from './HitModal';
import AsigneeModal from './AsigneeModal';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import CircularProgressBar from '../../CircularProgressBar';

import style from './index.scss';
import moment from 'moment';

import { find, isEqual } from '../../../util/lodashlike';
class InvestTable extends React.Component {
  static proptTypes = {
    theadData: PropTypes.array,
    subTheadData: PropTypes.array,
    filterStatusNo: PropTypes.number,
    topInfoMetadata: PropTypes.object,
    activeBU: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.state = {
      width: '100%',
      hitModal: {
        isShown: false,
        data: {}
      },
      selectedRow: 0,
      assignModal: {
        isShown: false,
        data: {}
      },
      isLoadingMore: false
    };

    //define refs
    this.investableDOM = null;
    this.investableRef = (element) => {
      this.investableDOM = element;
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();

    window.addEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.tbodyData, this.props.tbodyData)) {
      const { hitModal } = this.state;
      if (hitModal?.data) {
        const updatedAlert = find(nextProps.tbodyData, {
          alertId: hitModal['data']['alertId']
        });
        this.setState({
          ...this.state,
          isLoadingMore: false,
          hitModal: {
            ...hitModal,
            data: updatedAlert
          }
        });
        return;
      }

      this.setState({
        ...this.state,
        isLoadingMore: false
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onAssignConfirm = (e) => {
    e.stopPropagation();
    this.toggleAssignModal(e);
    this.toggleHitModal();
  };

  onCloseAlert = (e) => {
    e.stopPropagation();
    this.toggleHitModal();
  };

  onHitRowSelected = (i) => {
    this.setState({
      ...this.state,
      selectedRow: i
    });
  };

  toggleAssignModal = (e) => {
    e.stopPropagation();

    this.setState({
      assignModal: {
        isShown: !this.state.assignModal.isShown,
        data: {}
      }
    });
  };

  toggleHitModal = (i, alertData) => {
    this.setState({
      hitModal: {
        isShown: !this.state.hitModal.isShown,
        data: alertData
      }
    });
  };

  updateWindowDimensions = () => {
    this.setState({
      width: this.investableDOM ? this.investableDOM.getScrollWidth() : 0
    });
  };

  renderAssigneeModal = () => {
    const { assignModal } = this.state;

    if (!assignModal) {
      return <div />;
    }

    const investigatorData = [
      {
        id: 'invest001',
        name: 'James Bond',
        isStaff: true
      },
      {
        id: 'invest002',
        name: 'Tom Jackson',
        isStaff: false
      },
      {
        id: 'invest003',
        name: 'Will Hunt',
        isStaff: false
      },
      {
        id: 'invest004',
        name: 'Noey Pitt',
        isStaff: false
      },
      {
        id: 'invest005',
        name: 'Adrian Curry',
        isStaff: false
      },
      {
        id: 'invest006',
        name: 'Brandon Plic',
        isStaff: false
      }
    ];

    return (
      <AsigneeModal
        data={investigatorData}
        isShown={assignModal.isShown}
        toggleAssignModal={this.toggleAssignModal}
        onAssignConfirm={this.onAssignConfirm}
      />
    );
  };

  renderHitModal = () => {
    const { subTheadData, activeBU, topInfoMetadata } = this.props;
    const { hitModal, selectedRow } = this.state;

    if (hitModal?.data) {
      return (
        <HitModal
          subTheadData={subTheadData}
          activeBU={activeBU}
          topInfoMetadata={topInfoMetadata}
          isShown={hitModal.isShown}
          data={hitModal.data}
          selectedRow={selectedRow}
          onCloseAlert={this.onCloseAlert}
          toggleAssignModal={this.toggleAssignModal}
          toggleHitModal={this.toggleHitModal}
        />
      );
    }

    return null;
  };

  render() {
    const { theadData, subTheadData, tbodyData, filterStatusNo, isClickable } =
      this.props;
    const { width } = this.state;

    const activeStatus = mapActiveNoToStatus(filterStatusNo);

    if (!theadData || !subTheadData || !tbodyData) {
      return <div className={style.wrapper} />;
    }

    const headerLength = theadData.length;
    const tbodyLength = tbodyData.length;

    let theadCols = [];
    for (let i = 0; i < headerLength; i++) {
      const item = theadData[i];

      let groupCols = [];
      item.group.forEach((col) => {
        groupCols.push(<span className={style.headerSubCol}>{col.value}</span>);
      });

      theadCols.push(
        <div className={style.headerCol}>
          {item.value}
          {groupCols}
        </div>
      );
    }

    let tbodyRows = [];
    for (let i = 0; i < tbodyLength; i++) {
      const rowItem = tbodyData[i];

      // if(rowItem['alertStatus'].toUpperCase() !== activeStatus && activeStatus !== "ALL" ) continue

      let tbodyCols = [];
      for (let j = 0; j < headerLength; j++) {
        const colItem = theadData[j];

        let groupRowCols = [];
        colItem.group.forEach((subColItem, k) => {
          let groupSubColVal = rowItem;
          if (subColItem.name.includes('.')) {
            // determine the path within the object to access the value
            const keyPath = subColItem.name.split('.');
            keyPath.map((key) => {
              groupSubColVal = groupSubColVal[key] ? groupSubColVal[key] : '--';
            });
          }

          // Else, use the name as is to access the value
          if (!subColItem.name.includes('.')) {
            groupSubColVal =
              rowItem[subColItem.name] &&
              rowItem[subColItem.name] !== 'nan' &&
              rowItem[subColItem.name] !== ''
                ? rowItem[subColItem.name]
                : '--';
          }

          if (typeof groupSubColVal == 'object') {
            groupSubColVal =
              (groupSubColVal.name &&
                groupSubColVal.name !== '' &&
                groupSubColVal.name !== 'nan') ||
              '--';
          }

          if (subColItem.name === 'nsAlertReasonDesc') {
            if (rowItem && rowItem['alertStatus'] === 'Closed') {
              groupSubColVal = rowItem['nsAlertReasonDesc']
                ? rowItem['nsAlertReasonDesc']
                : '--';
            } else {
              groupSubColVal = '--';
            }
          }

          if (subColItem.name === 'closureDate') {
            if (rowItem && rowItem['alertStatus'] === 'Closed')
              groupSubColVal = rowItem?.['closureDate']
                ? moment(rowItem['closureDate']).format('DD/MM/YYYY')
                : '--';
            else groupSubColVal = '--';
          }

          if (subColItem.name === 'alertDate') {
            groupSubColVal = rowItem?.['alertDate']
              ? moment(rowItem['alertDate']).format('DD/MM/YYYY')
              : '--';
          }

          if (subColItem.name === 'alertStatus') {
            switch (rowItem['alertStatus']) {
              case '0':
                groupSubColVal = 'Open';
                break;
              case '2':
                groupSubColVal = 'Closed';
                break;
              case '1':
                groupSubColVal = 'Under Investigation';
                break;
              default:
                groupSubColVal = rowItem['alertStatus']
                  ? rowItem['alertStatus']
                  : '--';
                break;
            }
          }

          if (subColItem.name == 'alertScore') {
            let colorValue = null;
            switch (rowItem['alertLevel']) {
              case 'L1':
                colorValue = '#4CAF50';
                break;
              case 'L2':
                colorValue = '#ff934f';
                break;
              case 'L3':
                colorValue = '#E85252';
                break;
            }
            groupSubColVal = (
              <div className="row">
                <div className="col-sm-8">
                  <CircularProgressBar
                    key={colItem.name}
                    percentage={Number(groupSubColVal).toFixed(2)}
                    strokeFill={colorValue}
                  />
                </div>
              </div>
            );
          }

          groupRowCols.push(
            <span
              key={`bodyrow-${i}-col-${j}-subcol-${k}`}
              className={style.bodySubCol}>
              {groupSubColVal}
            </span>
          );
        });

        let colVal = rowItem;

        if (colItem.name.includes('.')) {
          // determine the path within the object to access the value
          const keyPath = colItem.name.split('.');
          keyPath.map((key) => {
            colVal = colVal[key];
          });
        }

        // Else, use the name as is to access the value
        if (!colItem.name.includes('.')) {
          colVal =
            rowItem[colItem.name] &&
            rowItem[colItem.name] !== 'nan' &&
            rowItem[colItem.name] !== ''
              ? rowItem[colItem.name]
              : '--';
        }

        if (colItem.name === 'alertStatus') {
          switch (rowItem['alertStatus']) {
            case '0':
              colVal = 'Open';
              break;
            case '2':
              colVal = 'Closed';
              break;
            case '1':
              colVal = 'Under Investigation';
              break;
            default:
              colVal = rowItem['alertStatus'] ? rowItem['alertStatus'] : '--';
              break;
          }
        }

        if (colItem.name == 'alertScore') {
          let colorValue = null;
          switch (rowItem['alertLevel']) {
            case 'L1':
              colorValue = '#4CAF50';
              break;
            case 'L2':
              colorValue = '#ff934f';
              break;
            case 'L3':
              colorValue = '#E85252';
              break;
          }
          colVal = (
            <div className="row">
              <div className="col-sm-8">
                <CircularProgressBar
                  key={colItem.name}
                  percentage={Number(rowItem['alertScore']).toFixed(2)}
                  strokeFill={colorValue}
                />
              </div>
            </div>
          );
        }

        tbodyCols.push(
          <div key={`row-${i}-col-${j}`} className={style.bodyCol}>
            {colVal}
            {groupRowCols}
          </div>
        );
      }

      // tbodyCols.push(<div key={`row-${i}-col-last`} className={style.bodyCol} >
      //   {rowItem['investigator'] && rowItem['investigator']["name"] ? null : <button className={style.actionBtn} onClick={this.toggleAssignModal}>Assign</button>}
      //   {rowItem['status'] != "Closed" ?
      //   <button className={style.actionBtn} onClick={this.onCloseAlert}>Close</button>
      //   : <button className={style.actionBtn} onClick={this.onReopen}>Reopen</button>}
      // </div>)

      const investTableRow = (
        <div
          key={`row-${i}`}
          style={{ background: i % 2 === 0 ? '#fff' : '#e9f2f8' }}
          className={style.tableRow}>
          {isClickable ? (
            <Link
              to={{
                pathname: `/app/ns/investigation/${rowItem.alertId}`,
                search: `?alertType=${rowItem.alertType}`
              }}
              key={`row-primary-${i}`}
              className={style.primaryRow}>
              {tbodyCols}
            </Link>
          ) : (
            <span className={style.primaryRow}>{tbodyCols}</span>
          )}
        </div>
      );

      tbodyRows.push(investTableRow);
    }

    return (
      <Scrollbars
        id="investable"
        ref={this.investableRef}
        style={{ height: 620 }}>
        <div className={style.wrapper} style={{ width: width }}>
          <div className={style.tableHeader}>{theadCols}</div>
          <div className={style.tableBody}>{tbodyRows}</div>
        </div>
        {/* {this.renderHitModal()}
      {this.renderAssigneeModal()} */}
      </Scrollbars>
    );
  }
}

const mapActiveNoToStatus = (activeNo) => {
  const mapping = ['ALL', 'OPEN', 'UNDER_INVESTIGATION', 'CLOSED'];

  return mapping[activeNo];
};

export default InvestTable;
